import React, { useEffect, useState } from 'react';
import NegativeMarksView from 'partial/OfferManager/modules/NegativeMarks/NegativeMarksView';
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner';
import ErrorMask from 'components/masks/ErrorMask';
import { useHistory } from 'react-router-dom';
import { CLICK_APPLY } from 'externals/_tracking/types/eventTypes.constants.js';
import { NEGATIVE_MARKS_ACTION } from 'types/morph.pagePosition.constants';
import { useViewModule, useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';

function NegativeMarksController(props) {
  const history = useHistory();
  const [negativeMarksOffer, setNegativeMarksOffer] = useState(null);

  const onClickApply = () => {
    props.eventHandler(CLICK_APPLY, {
      'Click Type': 'Apply',
      'Product Offer': negativeMarksOffer[0].id,
      'Product Id': negativeMarksOffer[0].creditRepairId,
    });
  };

  function homePageHandler() {
    history.goBack();
  }
  const atr = getViewModuleTrackingAttributes(
    NEGATIVE_MARKS_ACTION,
    props.modulePosition,
  );

  useViewModule(atr);

  const seenPixel = useSeenModulePixel(atr);

  useEffect(() => {
    if (!negativeMarksOffer && props.offers && props.offers.length > 0) {
      setNegativeMarksOffer(props.offers);
    }
  }, [props.offers, negativeMarksOffer]);

  if (props.error) {
    return (
      <ErrorMask
        title="Sorry there was an error."
        message={props.error.error}
        buttonLabel="Back to actions."
        onClick={homePageHandler}
      />
    );
  }
  if (props?.loading) {
    return <LoadingSpinner />;
  } else {
    return (
      <NegativeMarksView
        offer={negativeMarksOffer}
        onClickApply={onClickApply}
        seenPixel={seenPixel}
        {...props}
      />
    );
  }
}

export default NegativeMarksController;
